module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_1.d4c079e0.png";